<template>
  <div>
    <exo-form hideClose :root="_self" :clear="false">
      <template v-slot:titleTooltip>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="Data Generator Mission"
        >
          <tooltipDataGeneratorMission />
        </exo-help-dialog>
      </template>
      <exo-input-name :root="_self" />
      <v-divider />
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <div class="text-h6 white--text mb-4">Space Object</div>
              <exo-input-ref-notparametric
                :root="_self"
                name="spaceObject"
                type="spaceObject"
                componentRoute="/spaceobject"
              />
            </v-col>
          </v-row>
          <v-divider />
          <v-row>
            <v-col>
              <div class="text-h6 white--text mb-4">Orbits</div>
              <exo-input-ref-notparametric
                :root="_self"
                name="initialOrbit"
                type="orbit"
                componentRoute="/numericalorbit"
              />
              <exo-input-ref-notparametric
                :root="_self"
                name="targetOrbit"
                type="orbit"
                componentRoute="/numericalorbit"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </exo-form>
    <v-col ref="NumericalMissionErrorDisplay"> </v-col>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import plotLayout from '../../mixins/plotLayout.js'
import dataTools from '../../tools/data.js'
import missionTools from '../../store/mission.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import tooltipDataGeneratorMission from '../../components/Tooltips/Defense/tooltipDataGeneratorMission'

export default {
  name: 'DataGeneratorRequest',

  mixins: [formMixin, numericalMixin, plotLayout],
  components: {
    tooltipDataGeneratorMission
  },
  computed: {
    ...mapGetters(['missions', 'currentMission', 'currentUser'])
  },

  watch: {},

  async mounted() {
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    this.$root.$on('copy-mission', this.copyMission)
    this.$root.$on('create-mission', this.createMission)
    this.refreshSpaceObjects()
    this.refreshNumericalOrbits()
    this.refreshForm()
  },

  beforeDestroy() {
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
    this.$root.$off('copy-mission', this.copyMission)
    this.$root.$off('create-mission', this.createMission)
  },

  data() {
    return {
      enumPropertiesList: this.getEnumProperties(),

      missionPlot: null,

      modalRef: { content: [] },
      showModal: false,
      maneuveringStrategies: {},

      inputs: {
        spaceObject: null,
        initialOrbit: null,
        targetOrbit: {},
        sequenceType: this.getDefaultValue('sequenceType'),
        editing: true,
        type: this.getDefaultValue('type'),
        layout: this.getDefaultValue('layout') // to save the dashboard, should be optional in fieldsdescription to be automatically copied
      },
      spaceObjectsNotParametrics: [],
      orbitsNotParametrics: [],

      modalInfo: { title: '', content: '', config: {} },
      modalError: { title: '', content: '' },
      displayed: null
    }
  },

  methods: {
    refreshTable() {},

    refreshSpaceObjects() {
      let self = this
      this.$http
        .get(this.getAPI('spaceobjectdefinitions'))
        .then((response) => {
          self.spaceObjectsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of space objects. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    refreshNumericalOrbits() {
      let self = this
      this.$http
        .get(this.getAPI('orbitdefinitions'))
        .then((response) => {
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of numerical orbits. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getRequiredPropertiesList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getSubTypes(),
        'required'
      )
      return requiredList
    },
    getOptionalPropertiesList() {
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getSubTypes(),
        'optional'
      )
    },
    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getSubTypes(),
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getSubTypes(),
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getSubTypes(instance) {
      let types = {
        sequenceType: this.inputs.sequenceType
      }
      return types
    },

    getCurrentFormTitle() {
      return this.inputs.type + ' Mission'
    },

    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        for (const field in mission) {
          if (this.inputs.hasOwnProperty(field)) {
            this.inputs[field] = mission[field]
          }
        }
        this.inputs.editing = false
        this.sendFormToServer()
      }
    },

    currentMissionUpdatedHandler() {
      this.refreshForm()
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
        }
      }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        if (this.currentMission.id !== this.inputs.id) {
          // different mission reload completely the form
          this.edit(this.currentMission, 0)
        } else {
          // reloading the current mission
          // only refresh the updated fields
          const fieldsToUpdate = [
            this.orbitsNotParametrics,
            this.spaceObjectsNotParametrics
          ]
          missionTools.updateAllReferences(this, fieldsToUpdate)
          this.inputs.layout = this.currentMission.layout // might be saved from dashboard
        }
      }
    },

    updateAllReferences() {
      this.inputs.editing = true
      this.checkReferences(this.currentMission, this.inputs)
    },

    checkReferences(missionSource, missionToUpdate) {
      if (missionSource != null && missionToUpdate != null) {
        for (let field in this.getPropertiesDescription()) {
          if (missionSource[field] != null && missionToUpdate[field] != null) {
            if (
              missionSource[field].id != null &&
              missionSource[field].id === missionToUpdate[field].id
            ) {
              missionToUpdate[field] = missionSource[field]
            }
          }
        }
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    // redefine from form.js to keep the form open on the upadted data
    async onSave() {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },
    async onCreate() {
      let self = this
      let objectName = this.inputs.name.trim()
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          self.inputs.saving = false
          self.clearForm()
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard
          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          self.inputs.saving = false
          self.displayMessage(
            'Error creating ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          throw e
        })
    },
    getResultFieldType(field) {
      return dataTools.getFieldTypeFromPath(
        ['maneuverReport', field],
        'SimulationResult',
        null
      )
    },

    getResultDefaultUnitLabel(field) {
      let fieldType = this.getResultFieldType(field)
      return (
        ' ' + dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    // methods to mange form & table like other components

    getCurrentFormType() {
      return 'DataGeneratorRequest'
    }
  }
}
</script>
